import { render, staticRenderFns } from "./ph-category.vue?vue&type=template&id=32991d95&scoped=true"
import script from "./ph-category.vue?vue&type=script&lang=js"
export * from "./ph-category.vue?vue&type=script&lang=js"
import style0 from "./ph-category.vue?vue&type=style&index=0&id=32991d95&prod&lang=css"
import style1 from "./ph-category.vue?vue&type=style&index=1&id=32991d95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32991d95",
  null
  
)

export default component.exports